import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, Link } from "react-router-dom";

// @mui material components
import { Divider } from "@mui/material";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// DashboardDetailsSection page components
import DashboardDetailsSection from "pages/Dashboard/components/DashboardDetailsSection";

import { getMyClaimsList } from "actions/claimActions";
import DataTable from "examples/Tables/DataTable";
import MKBadge from "components/MKBadge";
import MKAvatar from "components/MKAvatar";
import moment from "moment";

function ClaimDetails({ title }) {
  const dispatch = useDispatch();

  const myListClaim = useSelector((state) => state.myListClaim);
  const { myClaimsList } = myListClaim;
  console.log(
    "🚀 ~ file: index.js:27 ~ ClaimDetails ~ myClaimsList:",
    myClaimsList
  );

  useEffect(() => {
    dispatch(getMyClaimsList());
  }, [dispatch]);

  const Company = ({ image, name, email }) => (
    <MKBox display="flex" alignItems="center" lineHeight={1}>
      <MKAvatar src={image} name={name} size="sm" />
      <MKBox>
        <MKTypography
          variant="button"
          fontWeight="medium"
          ml={1}
          lineHeight={1}
        >
          {name}
        </MKTypography>
        <MKBox mt={1.5}>
          <MKTypography variant="button" fontSize="small" ml={1} lineHeight={1}>
            {email}
          </MKTypography>
        </MKBox>
      </MKBox>
    </MKBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        company: (
          <Link to={`/claims/${item?._id}`}>
            <Company
              key={index}
              image={item?.order?.company?.companyLogo}
              name={item?.order?.company?.companyName}
              email={item?.order?.company?.companyEmail}
            />
          </Link>
        ),
        claim: (
          <MKBox>
            <MKTypography variant="caption" color="text" fontWeight="medium">
              {item?.claimNumber}
            </MKTypography>
            <MKBox mt={1.5}>
              <MKTypography variant="button" fontSize="small" lineHeight={1}>
                Ksh. {item?.amount}
              </MKTypography>
            </MKBox>
          </MKBox>
        ),
        policy: (
          <MKBox>
            <MKTypography variant="caption" color="text" fontWeight="medium">
              {item?.order?.policy?.policyName}
            </MKTypography>
            <MKBox mt={1.5}>
              <MKTypography variant="button" fontSize="small" lineHeight={1}>
                Ksh. {item?.order?.policy?.premiumAmount}
              </MKTypography>
            </MKBox>
          </MKBox>
        ),
        date: (
          <MKTypography variant="caption" color="text" fontWeight="medium">
            {moment(item?.created_at).format("DD MMM YYYY, HH mm")}
          </MKTypography>
        ),
        status: (
          <MKBox width="8rem" textAlign="center">
            <MKBox ml={-1}>
              <MKBadge
                badgeContent={item?.status}
                color={
                  item?.status == "pending"
                    ? "info"
                    : item?.status == "processing"
                    ? "primary"
                    : item?.status == "approved"
                    ? "success"
                    : item?.status == "rejected"
                    ? "dark"
                    : "light"
                }
                variant="gradient"
                size="sm"
              />
            </MKBox>
          </MKBox>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    // <Card id="delete-account">
    //   <MKBox pt={3} px={2}>
    //     <MKTypography variant="h6" fontWeight="medium">
    //       {title}
    //     </MKTypography>
    //   </MKBox>
    //   <Divider />
    //   <MKBox pt={1} pb={2} px={2}>
    <MKBox>
      <DataTable
        table={{
          columns: [
            {
              Header: "company",
              accessor: "company",
              width: "25%",
              align: "left",
            },
            {
              Header: "claim",
              accessor: "claim",
              width: "20%",
              align: "left",
            },
            {
              Header: "policy",
              accessor: "policy",
              width: "20%",
              align: "left",
            },
            {
              Header: "date",
              accessor: "date",
              width: "15%",
              align: "left",
            },
            {
              Header: "status",
              accessor: "status",
              width: "20%",
              align: "center",
            },
          ],

          rows: renderRows(myClaimsList),
        }}
        showTotalEntries={false}
        isSorted={false}
        noEndBorder
        entriesPerPage={false}
      />
    </MKBox>
    //   </MKBox>
    // </Card>
  );
}

export default ClaimDetails;
